import { localeCommon } from '@lib/tools/locale/source/web/common';

import { ReactComponent as FilterIcon } from '@components/web/src/assets/icons/button/filter.svg';
import { ReactComponent as ArrowRightCircleIcon } from '@components/web/src/assets/legacy/icons/btn_arrow_right_circle_icon.svg';
import { ReactComponent as CircleIcon } from '@components/web/src/assets/legacy/icons/btn_circle_icon.svg';
import { ReactComponent as RocketIcon } from '@components/web/src/assets/legacy/icons/btn_rocket_icon.svg';
import * as S from '@components/web/src/atoms/Buttons/styles';
import { IButtonProps, TButtonIconVariants } from '@components/web/src/atoms/Buttons/types';
import { LocationIcon } from '@components/web/src/atoms/Icons/LocationIcon';
import { SearchIcon } from '@components/web/src/atoms/Icons/SearchIcon';
import { StackIcon } from '@components/web/src/atoms/Icons/StackIcon';
import { Text } from '@components/web/src/foundations/Text/Text';

const Button = ({
  disabled = false,
  size = 'sm',
  fontSize = 'body1',
  text,
  variant = 'primary',
  iconVariant = 'none',
  handleClick,
  icon,
  type = 'button',
  iconPosition = 'left',
  textWeight = 'medium',
  textColor = '',
  localeOptions,
  isFullWidth = false,
  textDecoration = 'none',
  isPulseAnimation = false,
  isLoading = false,
  ...rest
}: IButtonProps) => {
  const icons: TButtonIconVariants = {
    arrow: <ArrowRightCircleIcon />,
    circle: <CircleIcon />,
    filter: <FilterIcon />,
    location: <LocationIcon className="mp-btn-icon" variant={variant} />,
    none: null,
    rocket: <RocketIcon />,
    search: <SearchIcon />,
    stack: <StackIcon className="mp-btn-icon" variant={variant} />,
  };
  const { slowApiWarningTitle } = localeCommon.lowSpeedWarning;
  const renderedIcon = icon || icons[iconVariant];

  return (
    <S.Button
      $hasText={!!text}
      $iconPosition={iconPosition}
      $isFullWidth={isFullWidth}
      $isPulseAnimation={isPulseAnimation}
      $size={size}
      $variant={variant}
      disabled={disabled || isLoading}
      type={type}
      onClick={handleClick}
      {...rest}
    >
      {renderedIcon && <S.Icon $iconPosition={iconPosition}>{renderedIcon}</S.Icon>}
      {text && (
        <Text
          color={textColor}
          localeOptions={localeOptions}
          size={fontSize}
          text={isLoading ? slowApiWarningTitle : text}
          textDecoration={textDecoration}
          weight={textWeight}
        />
      )}
    </S.Button>
  );
};

export default Button;
